import { OfferBannerStyles } from '@com-delta-idp/mnx-fast-action-banner-ui';

export const BannerStylesMocks: OfferBannerStyles = {
  offer: {
    annualFee: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#0b1f66',
      fontSize: '0.75rem',
      fontStyle: undefined,
      fontType: 'Whitney-Book',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    benefit: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#0b1f66',
      fontSize: '1rem',
      fontStyle: undefined,
      fontType: 'Whitney-Book',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    bullets: undefined,
    buttonLabel: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#0b1f66',
      fontSize: '0.875rem',
      fontStyle: undefined,
      fontType: 'Whitney-Semibold',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    checkLabel: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#0b1f66',
      fontSize: '0.9375rem',
      fontStyle: undefined,
      fontType: 'Whitney-Medium',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    checkSectionBackgroundColor: '#ffffff',
    containerStyles: {
      backgroundColor: '#ffffff',
      borderColor: 'none',
      fontColor: '',
      fontSize: '',
      fontStyle: undefined,
      fontType: '',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: 'full'
    },
    details: undefined,
    heading1: {
      backgroundColor: '#EDE5F9',
      fontColor: '#0b1f66',
      fontSize: '1.125rem',
      fontType: 'Whitney-Bold'
    },
    heading2: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#0b1f66',
      fontSize: '1.125rem',
      fontStyle: undefined,
      fontType: 'Whitney-Bold',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    image: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '',
      fontSize: '',
      fontStyle: undefined,
      fontType: '',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: 'left',
      reserveBackgroundColor: '',
      width: 'small'
    },
    links: {
      backgroundColor: '',
      borderColor: '',
      fontColor: '#4470C3',
      fontSize: '.6875rem',
      fontStyle: undefined,
      fontType: 'Whitney-Semibold',
      goldBackgroundColor: '',
      platinumBackgroundColor: '',
      position: undefined,
      reserveBackgroundColor: '',
      width: ''
    },
    actionOrientation: 'vertical'
  },
  creditSummary: {
    backgroundColor: '#f7ebd3',
    decimalPointsUi: {
      fontSize: '0.9375rem'
    },
    statementCreditLabel: {
      fontSize: '0.9375rem'
    },
    statementCreditUi: {
      fontSize: '0.9375rem'
    },
    total: {
      fontSize: '1.5rem'
    },
    totalLabel: {
      fontColor: '#0b1f66'
    }
  },
  welcome: {
    congratsSection: {
      fontColor: '#0b1f66'
    },
    welcomeBanner: {
      fontColor: '#0b1f66'
    },
    welcomeSection: {
      fontColor: '#0b1f66'
    }
  }
};
